import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TITLE: {
        id: 'ase.popUp.title',
        defaultMessage: 'PopUp message'
    },
    NO_MESSAGE: {
        id: 'ase.popUp.noMessage',
        defaultMessage: 'No message'
    },
    CONFIRMATION_MESSAGE: {
        id: 'ase.popUp.confirmationMessage',
        defaultMessage: 'I RECOGNIZED TO HAVE KNOWN THE MESSAGE ABOVE'
    },
});

export default messages;
